import { Segment } from "semantic-ui-react";

import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

import Button from "../../../ui/components/Buttons/Button";

import ErrorMessage from "../Messages/ErrorMessage";

export default function FileDropzone({ accept, onChange }) {
	const { t } = useTranslation();

	const { getRootProps, getInputProps, isDragReject } = useDropzone({
		accept,
		validator: (file) => {
			if (file.name.startsWith(".")) {
				return { code: "file-invalid" };
			}

			return null;
		},
		onDrop: (files) => onChange(files.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))),
	});

	return (
		<>
			<Segment placeholder {...getRootProps({ className: "dropzone" })}>
				<input {...getInputProps()} />

				<Button>{t("chooseFiles")}</Button>
			</Segment>

			{isDragReject && <ErrorMessage>{t("invalidFileTypeWarning")}</ErrorMessage>}
		</>
	);
}
